/* Salah On The Go — theme.js (vanilla, no deps) */
(function () {
  'use strict';
  var T = window.theme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var AR = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];

  function ar(str) {
    if (!T.money || T.money.arabic === false) return String(str);
    return String(str).replace(/[0-9]/g, function (d) { return AR[+d]; });
  }
  function money(cents) {
    var n = Math.round((cents || 0) / 100);
    var grouped = n.toLocaleString('en-US'); // 1,150
    grouped = ar(grouped.replace(/,/g, T.money && T.money.arabic !== false ? '٬' : ','));
    var label = (T.money && T.money.label) || 'ج.م';
    return (T.money && T.money.pos === 'before') ? (label + ' ' + grouped) : (grouped + ' ' + label);
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, 2200);
  }

  /* ---------- drawer ---------- */
  function overlay() { return $('[data-overlay]'); }
  function lock(on) { document.body.classList.toggle('lock', !!on); }
  function openCart() {
    var d = $('[data-cart-drawer]'); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    showOverlay();
  }
  function closeCart() {
    var d = $('[data-cart-drawer]'); if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }
    hideOverlayIfIdle();
  }
  function showOverlay() { var o = overlay(); if (o) { o.hidden = false; requestAnimationFrame(function(){ o.classList.add('is-open'); }); } lock(true); }
  function anyOpen() { return !!$('.cart-drawer.is-open,.menu-drawer.is-open,.search-drawer.is-open'); }
  function hideOverlayIfIdle() { if (anyOpen()) return; var o = overlay(); if (o) { o.classList.remove('is-open'); setTimeout(function(){ o.hidden = true; }, 300); } lock(false); }
  function openMenu() { var m = $('[data-menu-drawer]'); if (!m) return; m.classList.add('is-open'); m.setAttribute('aria-hidden','false'); showOverlay(); }
  function closeMenu() { var m = $('[data-menu-drawer]'); if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden','true'); } hideOverlayIfIdle(); }
  function openSearch() { var s = $('[data-search-drawer]'); if (!s) return; s.classList.add('is-open'); s.setAttribute('aria-hidden','false'); showOverlay(); var i = $('[data-search-input]', s); if (i) setTimeout(function(){ i.focus(); }, 80); }
  function closeSearch() { var s = $('[data-search-drawer]'); if (s) { s.classList.remove('is-open'); s.setAttribute('aria-hidden','true'); } hideOverlayIfIdle(); }
  function closeAll() { var c = $('[data-cart-drawer]'); if (c) c.classList.remove('is-open'); var m = $('[data-menu-drawer]'); if (m) m.classList.remove('is-open'); var s = $('[data-search-drawer]'); if (s) s.classList.remove('is-open'); hideOverlayIfIdle(); }

  /* ---------- cart API ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = ar(n); el.hidden = n === 0; });
    var c = $('[data-cd-count]'); if (c) c.textContent = '(' + ar(n) + ')';
  }
  function refreshDrawer() {
    return fetch(T.routes.root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['cart-drawer']; if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer]');
        var cur = $('[data-cart-drawer]');
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
      })
      .then(function () {
        return fetch(T.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { setCount(c.item_count); });
      });
  }
  function cartAdd(items) {
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function (j) { return refreshDrawer().then(function () { return j; }); })
      .catch(function (e) { toast((e && (e.description || e.message)) || T.strings.error); throw e; });
  }
  function cartChange(key, qty) {
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function () { return refreshDrawer(); })
      .catch(function () { toast(T.strings.error); });
  }

  /* ---------- global delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }
    if (t.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (t.closest('[data-menu-close]')) { e.preventDefault(); closeMenu(); return; }
    if (t.closest('[data-search-open]')) { e.preventDefault(); openSearch(); return; }
    if (t.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); return; }
    if (t.closest('[data-overlay]')) { closeAll(); return; }

    var qv = t.closest('[data-quick-view]');
    if (qv) { e.preventDefault(); e.stopPropagation(); openQuickView(qv.getAttribute('data-quick-view')); return; }

    var qa = t.closest && t.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault(); e.stopPropagation();
      var id = qa.getAttribute('data-quick-add');
      if (!id) return;
      qa.disabled = true;
      cartAdd([{ id: Number(id), quantity: 1 }])
        .then(function () { toast(T.strings.added); openCart(); })
        .catch(function () {})
        .then(function () { qa.disabled = false; });
      return;
    }

    var plus = t.closest && t.closest('[data-line-plus]');
    var minus = t.closest && t.closest('[data-line-minus]');
    if (plus || minus) {
      var row = (plus || minus).closest('[data-key]'); if (!row) return;
      var key = row.getAttribute('data-key');
      var span = row.querySelector('.qty span');
      var cur = parseInt((span.textContent || '1').replace(/[٠-٩]/g, function (d) { return AR.indexOf(d); }), 10) || 1;
      var next = plus ? cur + 1 : cur - 1;
      cartChange(key, next);
      return;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- predictive search ---------- */
  (function () {
    var box = $('[data-search-drawer]'); if (!box) return;
    var input = $('[data-search-input]', box); var results = $('[data-search-results]', box);
    if (!input || !results) return;
    var timer;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(T.routes.root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (!ps.length) { results.innerHTML = '<div class="search-sugg__empty">مفيش نتائج لـ "' + q + '"</div>'; return; }
            results.innerHTML = ps.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<span class="search-sugg__img"><img src="' + p.featured_image.url + '" alt=""></span>' : '<span class="search-sugg__img"></span>';
              var price = p.price ? '<span class="search-sugg__p">' + money(p.price) + '</span>' : '';
              return '<a href="' + p.url + '">' + img + '<span style="flex:1"><span class="search-sugg__t">' + p.title + '</span></span>' + price + '</a>';
            }).join('');
          }).catch(function () {});
      }, 220);
    });
  })();

  /* ---------- quick-view / quick-add modal ---------- */
  function qvEl() { return $('[data-quickview]'); }
  function closeQuickView() { var m = qvEl(); if (m) m.classList.remove('is-open'); lock(anyOpen()); }
  function openQuickView(handle) {
    var m = qvEl(); if (!m || !handle) return;
    var box = $('[data-qv-box]', m);
    box.innerHTML = '<div class="qv__loading">لحظة…</div>';
    m.classList.add('is-open'); lock(true);
    fetch(T.routes.root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { renderQuickView(box, p); })
      .catch(function () { box.innerHTML = '<div class="qv__loading">حصلت مشكلة، افتحي صفحة المنتج.</div>'; });
  }
  function renderQuickView(box, p) {
    var state = { opts: {}, img: (p.featured_image || (p.images && p.images[0]) || '') };
    // option index detection
    var names = p.options.map(function (o) { return (o && o.name) ? o.name : o; });
    var optValues = names.map(function (_, i) {
      var seen = [], out = [];
      p.variants.forEach(function (v) { var val = v.options[i]; if (val != null && seen.indexOf(val) === -1) { seen.push(val); out.push(val); } });
      return out;
    });
    var colorIdx = -1, setIdx = -1;
    names.forEach(function (n, i) {
      var s = String(n), nn = String(n).toLowerCase();
      if ((s.indexOf('لون') > -1 && s.indexOf('سجاد') === -1) || nn.indexOf('color') > -1) { if (colorIdx === -1) colorIdx = i; }
      if (s.indexOf('طقم') > -1 || nn.indexOf('set') > -1) setIdx = i;
    });
    var firstAvail = p.variants.find(function (v) { return v.available; }) || p.variants[0];
    names.forEach(function (_, i) { state.opts[i] = firstAvail.options[i]; });

    function findVariant() {
      return p.variants.find(function (v) {
        return v.options.every(function (ov, i) { return ov === state.opts[i]; });
      }) || p.variants[0];
    }
    function hexFor(name) { var m = window.SOTG_SWATCH || {}; return m[name] || m[String(name).toLowerCase()] || null; }

    function draw() {
      var v = findVariant();
      var sold = !v || !v.available;
      var img = (v && v.featured_image && v.featured_image.src) || state.img;
      var compare = v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '';
      var colorHtml = '';
      if (colorIdx > -1) {
        var vals = optValues[colorIdx];
        colorHtml = '<div class="opt"><div class="opt__label"><span class="muted">اللون: </span><strong>' + state.opts[colorIdx] + '</strong></div><div class="swatches">' +
          vals.map(function (cv) {
            var hx = hexFor(cv) || '#E9E1D2';
            var act = cv === state.opts[colorIdx] ? ' is-active' : '';
            return '<button type="button" class="swatch' + act + '" data-c="' + cv + '" title="' + cv + '"><span class="swatch__dot" style="background:' + hx + '"></span></button>';
          }).join('') + '</div></div>';
      }
      var setHtml = '';
      if (setIdx > -1) {
        var sv = optValues[setIdx];
        setHtml = '<div class="opt"><div class="opt__label"><strong>الطقم</strong></div><div class="setopts">' +
          sv.map(function (s) {
            var act = s === state.opts[setIdx] ? ' is-active' : '';
            return '<button type="button" class="setopt' + act + '" data-s="' + s + '"><span class="setopt__body"><strong>' + s + '</strong></span></button>';
          }).join('') + '</div></div>';
      }
      box.innerHTML =
        '<div class="qv__grid"><div class="qv__media"><button class="qv__close" data-qv-close aria-label="إغلاق">✕</button><img src="' + img + '" alt=""></div>' +
        '<div class="qv__body"><div class="qv__title">' + p.title + '</div>' +
        '<div class="qv__price"><strong>' + money(v.price) + '</strong>' + compare + '</div>' +
        colorHtml + setHtml +
        '<button type="button" class="atc" data-qv-add ' + (sold ? 'disabled' : '') + '><span>' + (sold ? 'نفد' : 'أضيفي للسلة') + '</span><span class="dot">·</span><span>' + money(v.price) + '</span></button>' +
        '<a href="' + p.url + '" class="buynow" style="text-align:center;line-height:54px;text-decoration:none">كل التفاصيل</a></div></div>';
      $$('[data-c]', box).forEach(function (b) { b.addEventListener('click', function () { state.opts[colorIdx] = b.getAttribute('data-c'); draw(); }); });
      $$('[data-s]', box).forEach(function (b) { b.addEventListener('click', function () { state.opts[setIdx] = b.getAttribute('data-s'); draw(); }); });
      var addBtn = $('[data-qv-add]', box);
      if (addBtn) addBtn.addEventListener('click', function () {
        var vv = findVariant(); if (!vv || !vv.available) return;
        addBtn.disabled = true;
        cartAdd([{ id: vv.id, quantity: 1 }]).then(function () { closeQuickView(); toast(T.strings.added); openCart(); }).catch(function () { addBtn.disabled = false; });
      });
    }
    draw();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-qv-close]')) { closeQuickView(); }
    if (e.target.classList && e.target.classList.contains('qv-overlay')) { closeQuickView(); }
  });

  /* ---------- product ---------- */
  function initProduct(root) {
    var variants;
    try { variants = JSON.parse($('[data-variants]', root).textContent); } catch (e) { variants = []; }
    if (!variants.length) return;

    var colorIdx = parseInt(root.dataset.coloridx, 10) || 0; // 1-based option index, 0 = none
    var setIdx = parseInt(root.dataset.setidx, 10) || 0;
    var matRequired = root.dataset.matrequired === 'true';
    var withMatValue = root.dataset.setSandValue || 'مع سجادة';
    var tierOff = { 1: 0, 2: (parseInt(root.dataset.tier2, 10) || 0) / 100, 3: (parseInt(root.dataset.tier3, 10) || 0) / 100 };

    var form = $('[data-atc-form]', root);
    var idInput = $('[data-variant-id]', root);
    var qtyInput = $('[data-qty-input]', root);
    var matProp = $('[data-mat-prop]', root);
    var mainImg = $('[data-main-img]', root);
    var thumbs = $$('[data-thumb]', root);

    var state = {
      color: colorIdx ? variants.find(function (v) { return v.available; }) || variants[0] : variants[0],
      setVal: null, mat: matProp ? matProp.value : null, tier: 1, imgIdx: 0
    };
    // initial color/set from first available
    var firstAvail = variants.find(function (v) { return v.available; }) || variants[0];
    state.colorVal = colorIdx ? firstAvail['o' + colorIdx] : null;
    state.setVal = setIdx ? firstAvail['o' + setIdx] : null;

    function optOf(v, idx) { return idx ? v['o' + idx] : null; }
    function findVariant() {
      return variants.find(function (v) {
        var okC = !colorIdx || optOf(v, colorIdx) === state.colorVal;
        var okS = !setIdx || optOf(v, setIdx) === state.setVal;
        return okC && okS;
      }) || variants.find(function (v) { return !colorIdx || optOf(v, colorIdx) === state.colorVal; }) || variants[0];
    }
    function tierTotal(v, n) { return Math.round(v.price * n * (1 - tierOff[n])); }

    function setImage(src) { if (mainImg && src) mainImg.src = src; }
    function activate(list, matchAttr, val) {
      $$(list, root).forEach(function (el) { el.classList.toggle('is-active', el.getAttribute(matchAttr) === val); });
    }

    function update() {
      var v = findVariant();
      var sold = !v || !v.available;

      // unit price
      var up = $('[data-unit-price]', root); if (up) up.textContent = money(v.price);
      var uc = $('[data-unit-compare]', root);
      if (uc) { if (v.compare > v.price) { uc.textContent = money(v.compare); uc.hidden = false; } else { uc.hidden = true; } }

      // color swatches active + sold flag
      if (colorIdx) {
        activate('[data-color]', 'data-color', state.colorVal);
        var cn = $('[data-color-name]', root); if (cn) cn.textContent = state.colorVal;
        var cs = $('[data-color-sold]', root); if (cs) cs.hidden = !sold;
        // mark sold-out swatches
        $$('[data-color]', root).forEach(function (btn) {
          var cv = btn.getAttribute('data-color');
          var anyAvail = variants.some(function (x) { return optOf(x, colorIdx) === cv && x.available; });
          btn.classList.toggle('is-sold', !anyAvail);
        });
      }

      // set option cards
      if (setIdx) {
        activate('[data-set]', 'data-set', state.setVal);
        $$('[data-set]', root).forEach(function (card) {
          var sv = card.getAttribute('data-set');
          var match = variants.find(function (x) { return optOf(x, setIdx) === sv && (!colorIdx || optOf(x, colorIdx) === state.colorVal); })
                   || variants.find(function (x) { return optOf(x, setIdx) === sv; });
          if (!match) return;
          var pr = card.querySelector('[data-set-price]'); if (pr) pr.textContent = money(match.price);
          var cp = card.querySelector('[data-set-compare]');
          if (cp) { if (match.compare > match.price) { cp.textContent = money(match.compare); cp.hidden = false; } else { cp.hidden = true; } }
          var tag = card.querySelector('[data-set-tag]');
          if (tag && match.compare > match.price) { tag.textContent = 'وفّري ' + money(match.compare - match.price); tag.hidden = false; }
        });
      }

      // mat picker visibility
      var showMat = matRequired || (setIdx && state.setVal === withMatValue);
      var mp = $('[data-mat-pick]', root); if (mp) mp.hidden = !showMat;
      if (matProp) { matProp.disabled = !showMat; matProp.value = state.mat || matProp.value; }

      // tiers
      $$('[data-tier]', root).forEach(function (card) {
        var n = parseInt(card.getAttribute('data-tier'), 10);
        var pr = card.querySelector('[data-tier-price]'); if (pr) pr.textContent = money(tierTotal(v, n));
        var cp = card.querySelector('[data-tier-compare]');
        var base = (v.compare > v.price ? v.compare : v.price) * n;
        if (cp) { if (tierTotal(v, n) < base) { cp.textContent = money(base); cp.hidden = false; } else { cp.hidden = true; } }
        card.classList.toggle('is-active', n === state.tier);
      });

      // ATC
      if (idInput) idInput.value = v.id;
      if (qtyInput) qtyInput.value = state.tier;
      var atcLabel = $('[data-atc-label]', root); if (atcLabel) atcLabel.textContent = sold ? 'اطلبيه Pre-order' : 'أضيفي للسلة';
      var atcTotal = $('[data-atc-total]', root); if (atcTotal) atcTotal.textContent = money(tierTotal(v, state.tier));
      var atcBtn = $('[data-atc]', root); if (atcBtn) atcBtn.disabled = false;

      // sticky
      var sl = $('[data-sticky-label]', root); if (sl) sl.textContent = sold ? 'اطلبيه Pre-order' : 'أضيفي للسلة';
      var st = $('[data-sticky-total]', root); if (st) st.textContent = money(tierTotal(v, state.tier));
      var sub = $('[data-sticky-sub]', root);
      if (sub) {
        var parts = [];
        if (state.colorVal) parts.push(state.colorVal);
        var tierLabel = state.tier === 1 ? 'قطعة' : (state.tier === 2 ? 'قطعتين' : '٣ قطع');
        parts.push(tierLabel);
        sub.textContent = parts.join(' · ');
      }
      var simg = $('[data-sticky-img]', root); if (simg && v.img) simg.src = v.img;

      // image follows color variant
      if (v.img && mainImg && mainImg.src.indexOf(v.img) === -1) {
        setImage(v.img);
        if (typeof v.mi === 'number') { state.imgIdx = v.mi; markThumb(); }
      }
      state.variant = v;
    }

    function markThumb() { thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === state.imgIdx); }); }

    // gallery
    thumbs.forEach(function (th, i) {
      th.addEventListener('click', function () {
        state.imgIdx = i; markThumb();
        var im = th.querySelector('img'); if (im && mainImg) mainImg.src = im.src.replace(/width=\d+/, 'width=1000');
      });
    });
    var galleryImgs = thumbs.map(function (t) { var im = t.querySelector('img'); return im ? im.src.replace(/width=\d+/, 'width=1000') : null; });
    function step(delta) {
      if (!galleryImgs.length) return;
      state.imgIdx = (state.imgIdx + delta + galleryImgs.length) % galleryImgs.length;
      markThumb(); if (galleryImgs[state.imgIdx] && mainImg) mainImg.src = galleryImgs[state.imgIdx];
    }
    var prev = $('[data-prev]', root); if (prev) prev.addEventListener('click', function () { step(1); });
    var next = $('[data-next]', root); if (next) next.addEventListener('click', function () { step(-1); });

    // color/set/mat/tier clicks
    $$('[data-color]', root).forEach(function (b) { b.addEventListener('click', function () { state.colorVal = b.getAttribute('data-color'); update(); }); });
    $$('[data-set]', root).forEach(function (b) { b.addEventListener('click', function () { state.setVal = b.getAttribute('data-set'); update(); }); });
    $$('[data-mat]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        state.mat = b.getAttribute('data-mat');
        if (matProp) matProp.value = state.mat;
        var mn = $('[data-mat-name]', root); if (mn) mn.textContent = state.mat;
        $$('[data-mat]', root).forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    });
    $$('[data-tier]', root).forEach(function (b) { b.addEventListener('click', function () { state.tier = parseInt(b.getAttribute('data-tier'), 10); update(); }); });

    // properties builder
    function properties() {
      var props = {};
      if (matProp && !matProp.disabled && matProp.value) props['لون السجادة'] = matProp.value;
      return props;
    }
    function addCurrent() {
      var v = state.variant || findVariant();
      var item = { id: v.id, quantity: state.tier };
      var props = properties(); if (Object.keys(props).length) item.properties = props;
      return cartAdd([item]);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[data-atc]', root); if (btn) btn.disabled = true;
        addCurrent()
          .then(function () { toast(T.strings.added); openCart(); })
          .catch(function () {})
          .then(function () { if (btn) btn.disabled = false; });
      });
    }
    var buynow = $('[data-buynow]', root);
    if (buynow) buynow.addEventListener('click', function () { addCurrent().then(function () { window.location.href = '/checkout'; }); });

    var stickyAdd = $('[data-sticky-add]', root);
    if (stickyAdd) stickyAdd.addEventListener('click', function () { addCurrent().then(function () { toast(T.strings.added); openCart(); }); });

    // FBT
    var fbt = $('[data-fbt]', root);
    if (fbt) {
      function fbtUpdate() {
        var checked = $$('[data-fbt-check]', fbt).filter(function (c) { return c.checked; });
        var total = checked.reduce(function (t, c) { var row = c.closest('[data-fbt-row]'); var pr = row.querySelector('[data-fbt-price]'); return t + (parseInt(pr.getAttribute('data-fbt-price'), 10) || 0); }, 0);
        var btn = $('[data-fbt-add]', fbt);
        if (btn) btn.textContent = checked.length ? ('أضيفي ' + ar(checked.length) + (checked.length > 1 ? ' منتجات' : ' منتج') + ' · ' + money(total)) : 'اختاري منتج';
      }
      $$('[data-fbt-row]', fbt).forEach(function (row) {
        row.addEventListener('click', function (e) {
          if (e.target.tagName === 'A') return;
          var chk = row.querySelector('[data-fbt-check]'); chk.checked = !chk.checked;
          row.classList.toggle('is-on', chk.checked);
          row.querySelector('.fbt__box').textContent = chk.checked ? '✓' : '';
          fbtUpdate();
        });
      });
      var fbtAdd = $('[data-fbt-add]', fbt);
      if (fbtAdd) fbtAdd.addEventListener('click', function () {
        var items = $$('[data-fbt-check]', fbt).filter(function (c) { return c.checked; }).map(function (c) { return { id: Number(c.value), quantity: 1 }; });
        if (!items.length) { toast('اختاري منتج الأول'); return; }
        cartAdd(items).then(function () { toast(T.strings.added); openCart(); });
      });
      fbtUpdate();
    }

    // sticky bar on scroll
    var bar = $('[data-sticky-bar]', root);
    var anchor = $('[data-atc]', root);
    if (bar && anchor) {
      var onScroll = function () {
        var past = anchor.getBoundingClientRect().bottom < 0;
        var drawerOpen = document.body.classList.contains('lock');
        bar.classList.toggle('is-show', past && !drawerOpen);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    update();
  }

  /* ---------- related products (recommendations) ---------- */
  function initRelated(root) {
    var url = root.getAttribute('data-url'); if (!url) return;
    if (root.querySelector('.pcard')) return; // already has fallback content
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var grid = tmp.querySelector('.pgrid'); var mine = root.querySelector('.pgrid');
      if (grid && mine) mine.innerHTML = grid.innerHTML;
    }).catch(function () {});
  }

  /* ---------- boot ---------- */
  function boot() {
    $$('[data-product-root]').forEach(initProduct);
    $$('[data-related]').forEach(initRelated);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
